module.exports = __webpack_public_path__ + "static/img/i8.b887be0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i8.png
// module id = s/UA
// module chunks = 0